import React, { Component, Fragment } from "react";
import BackendClient from "../../BackendClient";

import AuthContainer from "./auth";
import NewsContainer from "./news";
import ServicesContainer from "./services";
import Loading from "../../Components/Loading";

export default class Main extends Component {
  state = {
    isFetched: false,
    isFetching: false,
    hasError: false
  };

  getWidgetText = key => this.state.widgetTextMap.get(key) || "";

  renderWidgetBlock = (type, blockKey, props = {}) => {
    const __html = this.state.widgetTextMap.get(blockKey) || "";
    return React.createElement(type, {
      ...props,
      dangerouslySetInnerHTML: { __html }
    });
  };
  
  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount() {
    const { isFetching, isFetched, hasError } = this.state;
    if (!(isFetched && isFetching && hasError)) {
      !this.isCancelled && this.setState({ isFetching: true });
      BackendClient.getWidgetText({ title: "frontend.home.notAuthorized" })
        .fetchJson()
        .then(res => {
          if (res) {
            const widgetTextMap = new Map(
              (res || []).map(({ key, body }) => [key, body])
            );
            return (
              !this.isCancelled &&
              this.setState({
                isFetching: false,
                isFetched: true,
                widgetTextMap
              })
            );
          }
          return (
            !this.isCancelled &&
            this.setState({
              hasError: true,
              isFetched: true,
              errorMessage: "Fetch error"
            })
          );
        });
    }
  }

  render() {
    const { isFetched, isFetching, hasError, errorMessage } = this.state;
    if (isFetched) {
      if (hasError) {
        return `ERROR=${errorMessage}`;
      } else {
        return (
          <Fragment>
            <AuthContainer
              renderWidgetBlock={this.renderWidgetBlock}
              getWidgetText={this.getWidgetText}
            />
            <NewsContainer />
            <ServicesContainer renderWidgetBlock={this.renderWidgetBlock} />
          </Fragment>
        );
      }
    } else if (isFetching) {
      return <Loading loading />;
    }
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/containers/main/index.jsx